<template>
  <div class="checks">
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="filterNormal"
      title="FILTRAR"
    >
      <div class="row">
        <div v-if="$store.state.online" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Data</h6>
          <input type="date" v-model="date" class="form-control" />
        </div>
        <div v-if="$store.state.online" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="status" class="form-control">
            <option value="ATRASADO">ATRASADOS</option>
            <option value="CHECADO">CHECADOS</option>
            <option value="PENDENTE">PENDENTES</option>
            <option value="TODOS">TODOS</option>
          </select>
        </div>
        <div v-if="accessed_offline" class="col-md-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="date" class="form-control">
            <option
              v-for="advanceDate of advanceDates"
              :key="advanceDate"
              :value="advanceDate"
            >
              {{ String(advanceDate).split("-").reverse().join("/") }}
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
          <v-btn
            class="btn-modern btn-modern-delete m-1"
            @click="$bvModal.hide('filterNormal')"
            >CANCELAR</v-btn
          >
          <v-btn
            class="btn-modern btn-modern-save float-right"
            :disabled="loading"
            @click="handleFilter"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "FILTRAR" }}
          </v-btn>
        </div>
      </div></b-modal
    >
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-12">
        <h1 class="title-pages mb-1 check-text-center">PRESCRIÇÃO</h1>
        <h6
          v-if="$store.state.online"
          class="mb-0 upper-text worksansr check-text-center"
        >
          FILTRANDO MEDICAMENTOS:
          <strong class="color-blue">
            {{ handleTextStatus(status) }}
          </strong>
        </h6>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-4 col-sm-3 col-12 d-flex justify-content-end align-items-center"
      >
        <v-btn
          @click="$bvModal.show('filterNormal')"
          class="btn-modern btn-modern-info"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR</v-btn
        >
      </div>
      <div class="col-md-12 pt-0 pb-0 mb-4">
        <p class="m-0 text-fourteen color-sysblue">
          SÓ É POSSÍVEL SEPARAR MEDICAMENTOS DE LOTES QUE NÃO ESTEJAM VENCIDO!
        </p>
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="text-center p-5 v-clean" v-if="!exist">
        <h6 class="worksansr upper-text">Sem resultados!</h6>
      </div>
      <div
        v-for="(check, key) in checks"
        :key="key"
        class="col-md-12 pb-0 pt-0 mb-4"
        v-show="check.items.length > 0"
      >
        <div class="row checks-medicine-times">
          <div class="col-md-12 checks-medicine-times-header pt-0 pb-0 mb-1">
            <div class="row">
              <div
                class="col-md-12 d-flex check-justifique-left align-items-center"
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-capsules color-blue mr-2 text-twenty"></i>
                  <h6 class="m-0 check-text-center mr-2">MEDICAMENTOS</h6>
                  <span class="mr-2">|</span>
                  <h6
                    class="m-0 worksansr check-text-center"
                    v-if="check.items.length > 0"
                  >
                    <span v-if="check.time == 'null'">
                      EVENTUAL
                      {{ String(dateLabel).split("-").reverse().join("/") }}
                    </span>
                    <span v-else>
                      HORÁRIO {{ String(check.time).substr(0, 5) }} -
                      {{ String(dateLabel).split("-").reverse().join("/") }}
                    </span>
                  </h6>
                </div>
              </div>
              <div
                class="col-md-12 check-text-right checks-medicine-times-actions"
              >
                <SeparateSelected
                  class="mb-1"
                  v-on:success="handleSuccess"
                  v-on:remove-separate-warning="handleRemoveSeparateWarning"
                  :date="date"
                  :check_time="check.time"
                  :time="time"
                  :medicines_check="medicines_check"
                />
                <CheckSelected
                  class="mb-1"
                  v-on:success="handleSuccess"
                  :date="date"
                  :check_time="check.time"
                  :time="time"
                  :medicines_check="medicines_check"
                />
              </div>
            </div>
            <div
              v-if="check.time && check.time != 'null'"
              class="col-md-12 pt-0 pb-0 m-0"
            >
              <div class="form-check">
                <input
                  @input="handleCheckboxAll($event, check.time)"
                  :disabled="accessed_offline"
                  class="form-check-input check-input-medicine-all"
                  type="checkbox"
                  :id="`time-all-${check.time}`"
                  :data-time="check.time"
                />
                <label
                  class="check-text-center"
                  :for="`time-all-${check.time}`"
                >
                  SELECIONAR TODOS
                </label>
              </div>
            </div>
          </div>
          <div
            class="col-md-12 pb-0 pt-0 b-sidebar-body"
            v-for="(group_prescription_medicines, key) in check.items"
            :key="key"
          >
            <div class="row checks-medicine-time-medicines">
              <div
                class="col-md-12 pb-0 pt-1"
                v-for="(
                  group_prescription_medicine, key
                ) in group_prescription_medicines"
                :key="key"
              >
                <div
                  :class="[
                    'row',
                    group_prescription_medicine.prescription_medicine_time.box
                      ? 'checks-medicine-time-on-box'
                      : '',
                  ]"
                >
                  <div
                    class="col-md-12 checks-medicine-time-on-box-message"
                    v-if="
                      group_prescription_medicine.prescription_medicine_time.box
                    "
                  >
                    <p>
                      <i class="fas fa-cube mr-2"></i>
                      <i class="fas fa-capsules mr-2"></i>
                      MEDICAMENTO ESTÁ NA BOX
                    </p>
                  </div>
                  <div class="col-md-12">
                    <h6
                      class="checks-medicine-time-alert"
                      v-if="
                        group_prescription_medicine.prescription_medicine
                          .issetInStock == 0
                      "
                    >
                      Residente não possui medicamento no estoque!
                    </h6>
                    <h6
                      class="checks-medicine-time-alert"
                      v-if="
                        group_prescription_medicine.prescription_medicine
                          .longTerm
                      "
                    >
                      MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
                    </h6>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="form-check">
                      <input
                        :disabled="
                          group_prescription_medicine.medicine_check.status ==
                            'CHECADO' ||
                          group_prescription_medicine.prescription_medicine
                            .frequency == 'EVENTUAL' ||
                          accessed_offline
                        "
                        @input="handleCheckbox(check.time)"
                        class="form-check-input check-input-medicine"
                        type="checkbox"
                        :id="`medicine-${group_prescription_medicine.prescription_medicine_time.id}`"
                        :ref="`medicine-${group_prescription_medicine.prescription_medicine_time.id}`"
                        :data-time="check.time"
                        :data-status="
                          group_prescription_medicine.medicine_check.status
                            ? group_prescription_medicine.medicine_check.status
                            : 'FALSE'
                        "
                      />

                      <div class="check-text-center">
                        <h6 class="check-text-center">
                          <DataMedicine
                            :group_prescription_medicine="
                              group_prescription_medicine
                            "
                          />
                        </h6>
                      </div>
                    </div>
                    <div
                      v-if="
                        group_prescription_medicine.prescription_medicine
                          .frequency != 'EVENTUAL'
                      "
                      class="form-check pt-1"
                    >
                      <h6
                        class="legends worksansr"
                        v-if="
                          group_prescription_medicine.medicine_check.id &&
                          (group_prescription_medicine.medicine_check.status ==
                            'SEPARADO' ||
                            group_prescription_medicine.medicine_check.status ==
                              'CHECADO')
                        "
                      >
                        <strong class="upper-text">Separado por:</strong>
                        {{
                          professionalClassCouncilValue({
                            id: group_prescription_medicine.medicine_check
                              .separate_user.professional_class_council_id,
                            name: group_prescription_medicine.medicine_check
                              .separate_user.user_name,
                            cpf: group_prescription_medicine.medicine_check
                              .separate_user.user_cpf,
                            office:
                              group_prescription_medicine.medicine_check
                                .separate_user.user_office,
                            value:
                              group_prescription_medicine.medicine_check
                                .separate_user.professional_class_council_value,
                          })
                        }}
                      </h6>
                      <h6
                        class="legends worksansr"
                        v-if="
                          group_prescription_medicine.medicine_check.id &&
                          group_prescription_medicine.medicine_check.status ==
                            'CHECADO'
                        "
                      >
                        <strong class="upper-text">Checado por:</strong>

                        {{
                          professionalClassCouncilValue({
                            id: group_prescription_medicine.medicine_check
                              .checked_user.professional_class_council_id,
                            name: group_prescription_medicine.medicine_check
                              .checked_user.user_name,
                            cpf: group_prescription_medicine.medicine_check
                              .checked_user.user_cpf,
                            office:
                              group_prescription_medicine.medicine_check
                                .checked_user.user_office,
                            value:
                              group_prescription_medicine.medicine_check
                                .checked_user.professional_class_council_value,
                          })
                        }}
                      </h6>
                    </div>

                    <div
                      v-if="
                        group_prescription_medicine.prescription_medicine
                          .frequency == 'EVENTUAL'
                      "
                    >
                      <div
                        v-for="item of group_prescription_medicine
                          .prescription_medicine.quantity_of_times_checked"
                        :key="item.id"
                      >
                        <h6
                          class="legends worksansr"
                          v-if="
                            item.status == 'SEPARADO' ||
                            item.status == 'CHECADO'
                          "
                        >
                          <strong class="upper-text">Separado por:</strong>
                          {{
                            professionalClassCouncilValue({
                              id: item.separate_user
                                .professional_class_council_id,
                              name: item.separate_user.user_name,
                              cpf: item.separate_user.user_cpf,
                              office: item.separate_user.user_office,
                              value:
                                item.separate_user
                                  .professional_class_council_value,
                            })
                          }}
                          às {{ String(item.separate_time).substr(0, 5) }}
                        </h6>
                        <h6
                          class="legends worksansr"
                          v-if="item.status == 'CHECADO'"
                        >
                          <strong class="upper-text">Checado por:</strong>
                          {{
                            professionalClassCouncilValue({
                              id: item.checked_user
                                .professional_class_council_id,
                              name: item.checked_user.user_name,
                              cpf: item.checked_user.user_cpf,
                              office: item.checked_user.user_office,
                              value:
                                item.checked_user
                                  .professional_class_council_value,
                            })
                          }}
                          às {{ String(item.checked_time).substr(0, 5) }}
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center justify-content-center pt-0 pb-0"
                  >
                    <StatusMedicine
                      :prescription_medicine_time="
                        group_prescription_medicine.prescription_medicine_time
                      "
                      :medicine_check="
                        group_prescription_medicine.medicine_check
                      "
                      :eventual="check.time"
                      :date="date"
                    />
                  </div>
                  <div
                    class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                  >
                    <ActionMedicine
                      v-on:success="handleSuccess"
                      v-on:checked="$emit('checked')"
                      :resident_id="resident_id"
                      :date="date"
                      :group_prescription_medicine="group_prescription_medicine"
                    />
                  </div>

                  <div
                    class="col-md-12 pt-0 pb-0"
                    v-if="
                      group_prescription_medicine.medicine_check.data_base64
                    "
                  >
                    <ButtonGenerateCertificate
                      :modal_id="
                        group_prescription_medicine.medicine_check.data_base64
                      "
                      :id="group_prescription_medicine.id"
                      :data_base64="
                        group_prescription_medicine.medicine_check.data_base64
                      "
                    />
                  </div>

                  <div class="col-md-12 pt-0 pb-0">
                    <LinkVerLocalizacaoRegistro
                      :item="group_prescription_medicine.medicine_check"
                    />
                  </div>
                </div>
                <hr class="m-0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../templates/Components/ErrorsMessages";

import ButtonGenerateCertificate from "../../../../templates/Components/ButtonGenerateCertificate";

import LinkVerLocalizacaoRegistro from "../../../../templates/Components/LinkVerLocalizacaoRegistro";

import StatusMedicine from "../../../../templates/Prescription/Check/Status";

import DataMedicine from "../../../../templates/Prescription/Check/Medicine";

import ActionMedicine from "../../../../templates/Prescription/Check/Action";

import SeparateSelected from "../../../../templates/Prescription/Check/Action/SeparateSelected";

import CheckSelected from "../../../../templates/Prescription/Check/Action/CheckSelected";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { userData, getStatic } from "../../../../lib/functions";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import moment from "moment";

export default {
  name: "Checks",
  components: {
    ErrorsMessages,
    StatusMedicine,
    DataMedicine,
    ActionMedicine,
    SeparateSelected,
    CheckSelected,
    ButtonGenerateCertificate,
    LinkVerLocalizacaoRegistro,
  },
  data() {
    return {
      accessed_offline: false,
      rest_home_id: "",
      resident_id: "",
      date: moment().format("YYYY-MM-DD"),
      dateLabel: moment().format("YYYY-MM-DD"),
      time: "",
      status: "PENDENTE",
      start_date: "",
      end_date: "",
      checks: [],
      medicines_check: [],
      advanceDates: [],
      errors: [],
      loading: false,
      action_medicines_check: true,
      exist: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    professionalClassCouncilValue,
    handleCheckboxAll(event, time) {
      this.time = "";

      let { checks } = this;

      let checkboxs = document.querySelectorAll(".check-input-medicine");
      let checkboxsAll = document.querySelectorAll(".check-input-medicine-all");

      let medicines_check = [];
      let medicines_id = [];

      if (event.target.checked) {
        for (let checkboxAll of checkboxsAll) {
          if (checkboxAll.dataset.time == time) {
            checkboxAll.checked = true;
          } else {
            checkboxAll.checked = false;
          }
        }

        for (let checkbox of checkboxs) {
          if (checkbox.dataset.time == time) {
            medicines_id.push(checkbox.id);
            checkbox.checked = true;
          } else {
            checkbox.checked = false;
          }
        }

        for (let medicine_id of medicines_id) {
          for (let check of checks) {
            for (let item of check.items) {
              if (
                `medicine-${item.group_prescription_medicine.prescription_medicine_time.id}` ==
                medicine_id
              ) {
                let {
                  prescription_medicine,
                  prescription_medicine_time,
                  medicine_check,
                } = item.group_prescription_medicine;

                medicines_check.push({
                  prescription_medicine_time_id: prescription_medicine_time.id,
                  prescription_medicine_time: prescription_medicine_time,
                  medicine_check: medicine_check,
                  prescription_medicine: {
                    medicine_id: prescription_medicine.medicine_id,
                    medicine_type: prescription_medicine.medicine_type,
                    unit_of_measurement_id:
                      prescription_medicine.unit_of_measurement_id,
                    active_ingredient_id:
                      prescription_medicine.active_ingredient_id,
                  },
                });
              }
            }
          }
        }

        this.time = time;
        this.medicines_check = medicines_check;
      } else {
        for (let checkboxAll of checkboxsAll) {
          if (checkboxAll.dataset.time == time) {
            checkboxAll.checked = false;
          } else {
            checkboxAll.checked = false;
          }
        }

        for (let checkbox of checkboxs) {
          if (checkbox.dataset.time == time) {
            checkbox.checked = false;
          } else {
            checkbox.checked = false;
          }
        }

        this.time = "";
        this.medicines_check = [];
      }
    },
    handleTextStatus(status) {
      if (status == "ATRASADO") {
        return "ATRASADOS";
      } else if (status == "CHECADO") {
        return "CHECADOS";
      } else if (status == "PENDENTE") {
        return "PENDENTES";
      } else {
        return "TODOS";
      }
    },
    handleRemoveSeparateWarning(medicines) {
      let ids = medicines.map(
        ({ prescription_medicine_time_id }) =>
          `medicine-${prescription_medicine_time_id}`
      );

      let checkboxs = document.querySelectorAll(".check-input-medicine");

      for (let checkbox of checkboxs) {
        if (ids.includes(checkbox.id)) {
          checkbox.checked = false;
        }
      }

      let medicines_check = [];

      for (let item of this.medicines_check) {
        if (!ids.includes(`medicine-${item.prescription_medicine_time.id}`)) {
          medicines_check.push(item);
        }
      }

      this.medicines_check = medicines_check;
    },
    handleSuccess() {
      let checkboxs = document.querySelectorAll(".check-input-medicine");
      let checkboxsAll = document.querySelectorAll(".check-input-medicine-all");
      for (let checkboxAll of checkboxsAll) {
        checkboxAll.checked = false;
      }
      for (let checkbox of checkboxs) {
        checkbox.checked = false;
      }

      this.time = "";
      this.medicines_check = [];

      this.paginate();
    },
    handleCheckbox(time) {
      this.time = "";
      // this.action_medicines_check = false;

      let checkboxs = document.querySelectorAll(".check-input-medicine");

      let medicines_check = [];
      let medicines_id = [];

      for (let checkbox of checkboxs) {
        if (checkbox.dataset.time == time) {
          if (checkbox.checked) {
            medicines_id.push(checkbox.id);
          }
        } else {
          checkbox.checked = false;
        }
      }

      let { checks } = this;

      for (let medicine_id of medicines_id) {
        for (let check of checks) {
          for (let item of check.items) {
            if (
              `medicine-${item.group_prescription_medicine.prescription_medicine_time.id}` ==
              medicine_id
            ) {
              let {
                prescription_medicine,
                prescription_medicine_time,
                medicine_check,
              } = item.group_prescription_medicine;

              medicines_check.push({
                prescription_medicine_time_id: prescription_medicine_time.id,
                prescription_medicine_time: prescription_medicine_time,
                medicine_check: medicine_check,
                prescription_medicine: {
                  medicine_id: prescription_medicine.medicine_id,
                  medicine_type: prescription_medicine.medicine_type,
                  unit_of_measurement_id:
                    prescription_medicine.unit_of_measurement_id,
                  active_ingredient_id:
                    prescription_medicine.active_ingredient_id,
                },
              });
            }
          }
        }
      }

      this.time = time;
      this.medicines_check = medicines_check;
      // setTimeout(() => (this.action_medicines_check = true), 1);
    },
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { date } = routes.history.current.query;

      if (date) {
        this.date = date;
        this.dateLabel = date;
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        this.loading = false;
        let residents;
        try {
          residents = (await getStatic("/offline/residents/checks", true))
            .residents;
        } catch (errors) {
          this.errors = errors;
          return;
        }

        let resident = residents.find((item) => item.id == id);

        if (resident) {
          let advanceDates = [];
          for (let check of resident.checks) {
            advanceDates.push(check.date);
          }

          this.advanceDates = advanceDates;

          let { checks } = resident;

          if (checks[0] && checks[0].groupTimes) {
            let exist = false;
            for (let check of checks[0].groupTimes) {
              if (check.items.length > 0) {
                exist = true;
              }
            }

            this.exist = exist;
            this.checks = checks[0].groupTimes;
            this.dateLabel = checks[0].date;
          }
        }
      } else {
        await this.paginate();
      }
    },
    async paginate() {
      try {
        this.loading = true;
        this.errors = [];

        const {
          rest_home_id,
          resident_id,
          date,
          start_date,
          end_date,
          status,
        } = this;

        let params = {
          rest_home_id,
          resident_id,
          date,
          start_date,
          end_date,
          status,
        };

        const response = await api.get("/rest-home/resident/checks", {
          params,
        });

        const { error, errors, checks } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let exist = false;
          for (let check of checks) {
            if (check.items.length > 0) {
              exist = true;
            }
          }

          this.exist = exist;
          this.checks = checks;
          this.dateLabel = date;
          this.$bvModal.hide("filterNormal");
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },
    async handleFilter() {
      let { accessed_offline, resident_id, date } = this;
      if (accessed_offline) {
        this.checks = [];
        let residents = (await getStatic("/offline/residents/checks", true))
          .residents;

        let resident = residents.filter((item) => item.id == resident_id);

        if (resident[0]) {
          let { checks } = resident[0];

          let items = checks.filter((item) => item.date == date);

          if (items[0]) {
            let medicines = items[0].groupTimes;
            let exist = false;

            for (let check of medicines) {
              if (check.items.length > 0) {
                exist = true;
              }
            }
            this.exist = exist;
            this.checks = medicines;
            this.dateLabel = date;
          }
        }

        this.$bvModal.hide("filterNormal");
      } else {
        this.paginate();
      }
    },
  },
};
</script>

<style>
.checks li {
  list-style-type: none;
}

.checks .checks-medicine-times-actions {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

.checks .checks-medicine-times {
  border: 2px #d3d3d3;
  border-style: dashed;
  border-radius: 12px;
  padding: 5px;
}

.checks .checks-medicine-times-header {
  background-color: #f5f5f5;
  font-weight: 700;
}

.checks .checks-medicine-times-header h6 {
  font-size: 25px;
  font-weight: 700;
}

.checks .checks-medicine-time-on-box {
  border: 2px #6b976b;
  border-style: dashed;
  border-radius: 12px;
  background-color: #f3f8f3;
}

.checks .checks-medicine-time-on-box .checks-medicine-time-on-box-message {
  margin: 0;
  padding: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #6b976b;
}

.checks .checks-medicine-time-on-box .checks-medicine-time-on-box-message p {
  text-align: center;
  margin: 0;
  font-weight: 700;
  color: #fff;
}

.checks .checks-medicine-time-alert {
  background-color: #f8f2a0;
  padding: 10px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
}
</style>
